import { Button } from "@faire/web/slate/Button";
import { Column, Row } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";
import styled from "styled-components";

interface BannerContentProps {
  title?: string;
  message: string;
  icon?: React.ReactNode;
  ctaText?: string;
  ctaOnClick?: () => void;
}

export const FilterBannerContent: React.FC<BannerContentProps> = ({
  title,
  message,
  icon,
  ctaText,
  ctaOnClick,
}) => {
  return (
    <Wrapper>
      {icon ? (
        <Column
          style={{ marginRight: `${getSpacing("2x")}`, alignSelf: "center" }}
        >
          {icon}
        </Column>
      ) : null}
      <Column style={{ alignItems: "baseline" }}>
        {title ? (
          <>
            <Typography variant="paragraphSansMedium">{title}</Typography>
            <Typography variant="paragraphSansRegular">{message}</Typography>
          </>
        ) : (
          <Typography variant="paragraphSansMedium">{message}</Typography>
        )}
        {ctaText ? (
          <Button
            style={{ marginTop: `${getSpacing("1x")}` }}
            variant="tertiary"
            onClick={ctaOnClick}
          >
            {ctaText}
          </Button>
        ) : null}
      </Column>
    </Wrapper>
  );
};

// eslint-disable-next-line @faire/prefer-slate-attrs -- use ResponsiveContentV2
const Wrapper = styled(Row).attrs({ align: "baseline" })`
  padding-top: ${getSpacing("1x")};
  padding-bottom: ${getSpacing("1x")};
  &:empty {
    display: none;
  }
`;
